import { SvgIcon } from "@mui/material";

const CopyIcon = () => {
  return (
    <SvgIcon width="16" height="15" viewBox="0 0 16 15" fill="none">
      <g clipPath="url(#clip0_10_1579)">
        <path
          d="M6.44482 13.9446L12.667 13.9446C13.6489 13.9446 14.4448 13.1486 14.4448 12.1668L14.4448 5.94458C14.4448 4.96274 13.6489 4.1668 12.667 4.1668L6.44482 4.1668C5.46298 4.1668 4.66705 4.96274 4.66705 5.94458L4.66705 12.1668C4.66705 13.1486 5.46298 13.9446 6.44482 13.9446Z"
          stroke="#565656"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M2.66702 10.7046C2.01546 10.4406 1.55591 9.80233 1.55591 9.05566V2.83344C1.55591 1.85122 2.35146 1.05566 3.33369 1.05566H9.55591C10.3017 1.05566 10.9408 1.51522 11.2048 2.16678"
          stroke="#565656"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </SvgIcon>
  );
};

export default CopyIcon;
